import Callout from '../components/Callout';
import Carousel from '../components/Carousel';
import Content from '../components/Content';
import TeamMember from '../components/TeamMember';
import './About.scss';

const About = () => {
    return (
        <div className="about-page">
            <section className="page">
                <div className="container">
                    <Callout
                        title="Progressive corporate workers, looking to share their skills with the world."
                        eyebrow="About Us"
                        description="The tech industry has created this facade that good tech needs to be expensive. We're here to prove them wrong."
                    >
                        <p>
                            In late 2024, a bunch of us got together to talk about how crazy expensive tech can be, especially if you aren't particularly tech-savvy.
                        </p>
                        <p>
                        Many of us had experience with tech consulting and development, from creating static websites, data analytics tools, all the way to B2B web applications: and there was one common thread amongst all our experiences.
                        </p>
                        <p><span className='bold'>We were always floored at the amount of money that our employers were charging clients.</span> So we decided to do something about it.</p>
                    </Callout>
                </div>
                <Content heading="Our Biscuits" sectionId='values'>
                    <Carousel />
                </Content>
                <Content heading="Collective Leadership" variation="inverse" sectionId='leaders'>
                    <div className='container members'>
                        <TeamMember 
                            imageURL='/team/1.png'
                            displayName='Em Goroza'
                            title='Chief Technology Officer'
                            pronouns='she/hers'
                            socials={{
                                linkedIn: 'https://linkedin.com/in/egoroza',
                                gitHub: 'https://github.com/egoroza'
                            }}
                        >
                            <p>Em is a seasoned professional in the tech industry, with a main focus on software development and seamless user experiences. As both a developer and a designer, Em takes pride in making her work as accessible as possible. She has a diverse array of experiences from startups to large companies, including Wayfair and Kiva.</p>

                            <p>Outside the collective, Em also runs a grassroots nonprofit called Panethnic Pourovers, where she is responsible for day-to-day operations, grant writing, maintaining digital tooling and presence, and donor relations. Em is based in Boston, Massachusetts.</p>
                        </TeamMember>
                        <TeamMember 
                            imageURL='/team/2.png'
                            displayName='Gaurab Pant'
                            title='Software Engineer'
                            pronouns='he/him'
                            socials={{
                                linkedIn: 'https://www.linkedin.com/in/bgpant/',
                                gitHub: 'https://github.com/gaurab-pant'
                            }}
                        >
                            <p>Gaurab is a Software Developer who cares about the human detail in Front End design. Born in Nepal, he has a variety of interests in community work and non-profits. He recently worked at Open Earth Foundation as a Software Engineer and currently devotes his time in a housing non-profit called Phipps Neighborhoods.</p>

                            <p>His interests include movies, Pokémon, and finding good and cheap eats in NYC. He is based in Woodside, New York.</p>
                        </TeamMember>
                    </div>
                </Content>
            </section>
        </div>
    )
}

export default About;